'use client';

import React, { useEffect, useRef } from 'react';
import {
  createWebGlKeyer,
  destroyKeyer,
  drawSource
} from '../../helpers/webgl';

function ChromaKeyCanvas({ videoElementId, isStreaming, settings }) {
  const canvasRef = useRef(null);
  const settingsRef = useRef(settings);

  useEffect(() => {
    settingsRef.current = settings;
  }, [settings]);

  useEffect(() => {
    let frameId = 0;
    const canvas = canvasRef.current;
    if (!canvas) return;

    const keyer = createWebGlKeyer(canvas);
    if (!keyer) return;

    const activeKeyer = keyer;
    const { gl } = activeKeyer;

    function draw() {
      const video = document.getElementById(videoElementId);

      if (isStreaming && video && video.readyState >= 2) {
        drawSource(video, canvas, settingsRef.current, gl, activeKeyer);
      }

      frameId = window.requestAnimationFrame(draw);
    }

    frameId = window.requestAnimationFrame(draw);

    return () => {
      window.cancelAnimationFrame(frameId);
      destroyKeyer(activeKeyer);
    };
  }, [isStreaming, videoElementId]);

  return (
    <>
      <canvas
        ref={canvasRef}
        className={`absolute top-0 left-0 w-full h-full object-cover object-top`}
        aria-label='Green-screen keyed Anam avatar'
      />
    </>
  );
}

export default ChromaKeyCanvas;
